export const PeriodNames: { [key: string]: string } = {
  AmericanFootball: 'Quarter',
  AustralianFootball: 'Quarter',
  Badminton: 'Game',
  BallHockey: 'Half',
  Baseball: 'Inning',
  Basketball: 'Quarter',
  BeachFootball: 'Half',
  BeachHandball: 'Half',
  BeachVolleyball: 'Set',
  Bowls: 'End',
  Boxing: 'Round',
  CounterStrike: 'Map',
  Cricket: 'Inning',
  Curling: 'End',
  CyberFootball: 'Half',
  Dota2: 'Game',
  EBasketball: 'Quarter',
  Floorball: 'Period',
  Futsal: 'Half',
  GaelicFootball: 'Half',
  GearsOfWar: 'Game',
  Handball: 'Half',
  Hearthstone: 'Game',
  HeroesOfTheStorm: 'Game',
  Hockey: 'Period',
  IceHockey: 'Period',
  LeagueOfLegends: 'Game',
  Mma: 'Round',
  MortalKombatXL: 'Game',
  Netball: 'Quarter',
  Overwatch: 'Game',
  RugbyLeague: 'Half',
  RugbySevens: 'Half',
  RugbyUnion: 'Half',
  Smite: 'Game',
  Snooker: 'Frame',
  Soccer: 'Half',
  StarCraft: 'Game',
  StarCraft2: 'Game',
  TableTennis: 'Set',
  Tekken7: 'Game',
  Tennis: 'Set',
  Volleyball: 'Set',
  WarcraftIII: 'Game',
  WaterPolo: 'Quarter',
  WorldOfTanks: 'Game',
  WorldOfWarcraft: 'Game',
  PistolShooting: 'Set',
  PistolHead2Head: 'Set',
  ArcheryH2H: 'Set',
  CompoundArchery: 'Set',
  Archery: 'Set',
  BasketballShots: 'Shot',
  Valorant: 'Map',
  AgeofEmpires: 'Game',
  ApexLegends: 'Game',
  ArenaOfValor: 'Game',
  Artifact: 'Game',
  CallOfDuty: 'Game',
  CounterStrike2: 'Map',
  CrossFire: 'Map',
  FreeFire: 'Round',
  Halo: 'Map',
  KingOfGlory: 'Game',
  Overwatch2: 'Game',
  Quake: 'Map',
  RainbowSix: 'Map',
  RocketLeague: 'Game',
  Vaingloory: 'Game',
  MobileLegends: 'Game'

  // The list is not complete, we need period names for other sports as well
};
